import Const from 'constants';

const ModesConfig = {
    setModesConfig(sportConfig) {
        return {
            type: Const.MODES_CONFIG_INIT,
            sportConfig,
        };
    },
};

export default ModesConfig;
